'use client';

import { c as _c } from "react/compiler-runtime";
import { SerwistProvider as BaseSerwistProvider } from '@serwist/turbopack/react';
import { type ReactNode } from 'react';
const BYPASS_SECRET = process.env.NEXT_PUBLIC_APP_ENVIRONMENT === 'PROD' ? undefined : process.env.NEXT_PUBLIC_VERCEL_BYPASS_SECRET;
const swUrl = BYPASS_SECRET ? `/sw.js?x-vercel-protection-bypass=${BYPASS_SECRET}` : '/sw.js';
export const SerwistProvider = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <BaseSerwistProvider cacheOnNavigation={true} disable={process.env.NODE_ENV === "development"} reloadOnOnline={true} swUrl={swUrl}>{children}</BaseSerwistProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};